import React, { useState } from 'react';
import {Grid,Box,Typography,TextField,FormControlLabel,Checkbox,Button,InputAdornment} from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import SecurityIcon from '@mui/icons-material/Security';
import { useNavigate, Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import axios from 'axios';

export default function LoginPage() {
  const [userdata, setUserdata] = useState({ email: '', password: '' });
  const [showpassword, setShowpassword] = useState(false);
  const navigate = useNavigate();

  const handler = (e) => {
    const { name, value } = e.target;
    setUserdata({ ...userdata, [name]: value });
  };

  const toggleShowPassword = () => {
    setShowpassword((prev) => !prev);
  };

  const submitdata = (e) => {
    e.preventDefault();
    axios
      .post(`${process.env.REACT_APP_API_LINKS}/auth/login`, userdata, { withCredentials: true })
      .then((res) => {

        if (res.status === 200) {
          Swal.fire({
            title: 'log in success',
            icon: 'success',
            showConfirmButton: false,
            timer: 1000
          });
          window.location.reload()
          navigate('/');
        }
      })
      .catch((err) => {
        if (err.status === 401) {
          Swal.fire({
            title: 'wrong credientials entered',
            icon: 'error',
            showConfirmButton: false,
            timer: 1000
          });
        } 
         else
          if (err.status === 404) {
          Swal.fire({
            title: 'No user found with the email',
            icon: 'error',
            showConfirmButton: false,
            timer: 1000
          });
        }
        else 
           if (err.status === 450) {
          Swal.fire({
            title: 'Your Subscription is Outdated',
            icon: 'error',
            showConfirmButton: false,
            timer: 1000
          });
        }
          else {
          Swal.fire({
            title: 'The Internet?',
            text: 'That thing is still around?',
            icon: 'question'
          });
        }
      });
  };

  return (
    <Grid container sx={{ minHeight: '100vh', flexDirection: { xs: 'column', md: 'row' }, alignItems: 'center', justifyContent: 'center', p: { xs: 1, md: 4 } }}>
      
      <Grid item xs={12} md={6} lg={4} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', p: { xs: 0, sm: 6 }, textAlign: 'center', mx: 'auto' }}>
        <Box sx={{ mb: 1 }}>
          <img src="suntech_logo.png" alt="Logo" style={{ height: 75, marginBottom: 10 }} />
        </Box>
        <Typography variant="h4" sx={{ fontWeight: 800, mt:{xs:1,sm:3,md:3,lg:3} , fontFamily: 'poppins' }}>
          Welcome to CRM
        </Typography>
        <img src="Lock.png" alt="Security Illustration" style={{ width: '70%', maxWidth: 500, marginTop: 16 }} />
      </Grid>

      <Grid item xs={12} md={6} sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 3,
        mt: { xs: 0, md: 0 },
        mx: 'auto'
      }}>
        <Box sx={{
          width: '100%',
          maxWidth: 400,
          p: 4,
          borderRadius: '5px',
          backgroundColor: '#fff',
          boxShadow: "1px 1px 20px rgba(128, 128, 128, 0.7)",
          textAlign: 'center'
        }}>
          <Typography variant="h5" sx={{ fontWeight: 600, mb: 3, fontFamily: 'poppins' }}>
            Login
          </Typography>

          <TextField
            fullWidth
            name="email"
            label="Email"
            margin="normal"
            value={userdata.email}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <EmailIcon />
                </InputAdornment>
              )
            }}
            sx={{
              fontFamily: 'poppins',
              '& .MuiOutlinedInput-root': { borderRadius: '10px' },
              '& input::placeholder': { fontFamily: 'poppins' }
            }}
            onChange={handler}
          />

          <TextField
            fullWidth
            name="password"
            label="Password"
            type={showpassword ? 'text' : 'password'}
            margin="normal"
            value={userdata.password}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <SecurityIcon />
                </InputAdornment>
              )
            }}
            sx={{
              fontFamily: 'poppins',
              '& .MuiOutlinedInput-root': { borderRadius: '10px' },
              '& input::placeholder': { fontFamily: 'poppins' }
            }}
            onChange={handler}
          />

          <Box sx={{ display: 'flex',flexDirection:{xs:'column',lg:'row',md:'row'} ,justifyContent: {sx:'center',md:'space-between',lg:'space-between'}, alignItems: 'center', my: 2, fontFamily: 'poppins' }}>
            <FormControlLabel
              control={<Checkbox checked={showpassword} onChange={toggleShowPassword} />}
              label="Show Password"
            />
            <Link to="/forgot" style={{ textDecoration: 'none', fontFamily: 'poppins', color: '#007ee5' }}>
              Forgot Password?
            </Link>
          </Box>

          <Button fullWidth variant="contained" sx={{
            backgroundColor: '#007ee5',
            textTransform: 'none',
            mb: 2,
            fontFamily: 'poppins'
          }} onClick={submitdata}>
            Login to Account
          </Button>

        </Box>
      </Grid>
    </Grid>
  );
}
